import React from 'react';
import {
    Box,
    Container,
    Stack,
    Text,
    Link,
    Image,
    Divider,
    HStack,
    VStack,
} from '@chakra-ui/react';

import instagramIcon from '../../assets/Landing/Instagram.svg';
import linkedInIcon from '../../assets/Landing/linkedin.svg';
import tikTokIcon from '../../assets/Landing/tiktok.svg';
import googlePlayIcon from '../../assets/Landing/GooglePlayLogo.svg';
import appStoreIcon from '../../assets/Landing/AppleStoreLogo.svg';
import teaLogo from '../../assets/tea-logoVersion.svg';

const Footer = () => {
    return (
        <Box bg="var(--TEA-Light-Teal, #FFFF)" color="gray.600">
            <Container as={Stack} maxW={'6xl'} py={10}>
                <HStack justifyContent="space-between">
                    <VStack align={'flex-start'} spacing={4}>
                        <Image src={teaLogo} alt="TEA Logo" />
                        <Text fontSize="sm" color="var(--500, #313C45)" fontFamily="Quicksand" fontWeight="500" lineHeight="24px" mt={1.5}>
                            Say “Hello” without saying “Hello”
                        </Text>
                        <Stack direction={'row'} spacing={3} mt={2.5}>
                            <Image src={googlePlayIcon} />
                            <Image src={appStoreIcon} />
                        </Stack>
                    </VStack>
                    <HStack alignItems="start" spacing={10}>
                        {/* <VStack align={'flex-start'} spacing={4}>
                            <Text fontWeight={'bold'} color="var(--600, #0D1216)" fontFamily="Quicksand" fontSize="16px" lineHeight="25px">
                                Quick Links
                            </Text>
                            <Link href={'#'}>Home</Link>
                            <Link href={'#'}>Features</Link>
                            <Link href={'#'}>Demo</Link>
                            <Link href={'#'}>Partnerships</Link>
                            <Link href={'#'}>About</Link>
                            <Link href={'#'}>FAQ</Link>
                        </VStack> */}
                        <VStack align={'flex-start'} spacing={4} ml="100px">
                            <Text fontWeight={'bold'} color="var(--600, #0D1216)" fontFamily="Quicksand" fontSize="16px" lineHeight="25px">
                                Connect with us
                            </Text>
                            <Link href={'https://www.instagram.com/tea_app_/'} isExternal>
                                <Stack direction={'row'} align={'center'} spacing={2}>
                                    <Image src={instagramIcon} boxSize="22px" />
                                    <Text color="var(--4OO, #48555F)" fontFamily="Quicksand" fontWeight="600" lineHeight="19px">Instagram</Text>
                                </Stack>
                            </Link>
                            <Link href={'https://www.linkedin.com/company/teavideogame/'} isExternal>
                                <Stack direction={'row'} align={'center'} spacing={2}>
                                    <Image src={linkedInIcon} boxSize="22px" />
                                    <Text color="var(--4OO, #48555F)" fontFamily="Quicksand" fontWeight="600" lineHeight="19px">LinkedIn</Text>
                                </Stack>
                            </Link>
                            <Link href={'https://tiktok.com'} isExternal>
                                <Stack direction={'row'} align={'center'} spacing={2}>
                                    <Image src={tikTokIcon} boxSize="22px" />
                                    <Text color="var(--4OO, #48555F)" fontFamily="Quicksand" fontWeight="600" lineHeight="19px">TikTok</Text>
                                </Stack>
                            </Link>
                        </VStack>
                    </HStack>

                </HStack>
                <Divider my={4} borderColor="gray.300" />
                <Stack direction={'row'} justifyContent={'space-between'} mt={10} align="center">
                    <Stack direction={'row'} spacing={6}>
                        <Link href={'#'}>Privacy Policy</Link>
                        <Link href={'#'}>Terms & Conditions</Link>
                        <Link href={'#'}>Support</Link>
                    </Stack>
                    <Text color="var(--600, #0D1216)" fontFamily="Quicksand" fontSize="14px" fontWeight="600" lineHeight="24px" textAlign="right">
                        © TEA Copyright 2024, All Rights Reserved
                    </Text>
                </Stack>
            </Container>
        </Box>
    );
};

export default Footer;
